const Cesium = window.Cesium
const { AmapImageryProvider,BaiduImageryProvider, GeoVisImageryProvider,TdtImageryProvider,GoogleImageryProvider } = window
const getCesiumToken = () => {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5N2U5NmViZi1kNTRlLTQ1MGUtOTE3Zi0yMmVmMTljNzQwN2MiLCJpZCI6MTE0MDg3LCJpYXQiOjE2Njc4ODk5ODV9.-hPtbj2jEOTglQ8V57rCqhT16FC8FANgQR3YusyvvMU'
}
const xMeterToDegree = 0.000008993216192195822
const yMeterToDegree = 0.0000114255544679108
const CoreMapTd = {
  zoom(extent,viewer,type = 'fly'){
    const radians = []
    extent.forEach((degree) => {
      radians.push(Cesium.Math.toRadians(degree))
    })
    const rectangle = new Cesium.Rectangle(radians[0], radians[1], radians[2], radians[3])
    type === 'fly' ? viewer.camera.flyTo({ destination: rectangle }) : viewer.camera.setView({ destination: rectangle })
  },
  moveToPoint(pt, viewer, type = 'fly'){
    const destination = Cesium.Cartesian3.fromDegrees(pt[0],pt[1],pt[2] || 15000.0)
    type === 'fly' ? viewer.camera.flyTo({ destination: destination }) : viewer.camera.setView({ destination: destination })
  },
  getResolution(viewer){
    let scene = viewer.scene;
    // 获取画布的大小
    var width = scene.canvas.clientWidth;
    var height = scene.canvas.clientHeight;
    //获取画布中心两个像素的坐标（默认地图渲染在画布中心位置）
    var left = scene.camera.getPickRay(new Cesium.Cartesian2(0, height / 2));
    var right = scene.camera.getPickRay(new Cesium.Cartesian2(width, height / 2));

    var globe = scene.globe;
    var leftPosition = globe.pick(left, scene);
    var rightPosition = globe.pick(right, scene);

    if (!Cesium.defined(leftPosition) || !Cesium.defined(rightPosition)) {
      return;
    }

    var leftCartographic = globe.ellipsoid.cartesianToCartographic(leftPosition);
    var rightCartographic = globe.ellipsoid.cartesianToCartographic(rightPosition);
    var geodesic = new Cesium.EllipsoidGeodesic();

    geodesic.setEndPoints(leftCartographic, rightCartographic);
    return geodesic.surfaceDistance / (width * 111111);//分辨率

  },
  createViewer(id,props_data){
      Cesium.Ion.defaultAccessToken = getCesiumToken();
      const props = Object.assign({
          animation: false, // 动画小组件
          baseLayerPicker: false, // 图层选择器
          fullscreenButton: false, // 全屏组件
          vrButton: false, // VR模式
          geocoder: true, // 地理编码（搜索）组件
          homeButton: false, // 首页，点击之后将视图跳转到默认视角
          infoBox: false, // 信息框
          sceneModePicker: false, // 场景模式，切换2D、3D 和 Columbus View (CV) 模式。
          selectionIndicator: false, //是否显示选取指示器组件
          timeline: false, // 时间轴
          navigationHelpButton: false, // 帮助提示，如何操作数字地球。
          shouldAnimate: false,
          // imageryProviderViewModels: getProviderViewModels(),
      },props_data || {});
      
      const viewer = new Cesium.Viewer(id, props);
      //去掉LOGO
      viewer.cesiumWidget.creditContainer.style.display = "none";

      const options = {}
      // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和 Cesium.Rectangle.
      //options.defaultResetView = new Cesium.Rectangle.fromDegrees(80, 22, 130, 50)
      //new Cesium.Rectangle.fromDegrees(113.8980, 22.4899, 113.9686, 22.5438)
      // 用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
      options.enableCompass = false
      // 用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件将不会添加到地图中。
      options.enableZoomControls = false
      // 用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
      options.enableDistanceLegend = false
      // 用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
      options.enableCompassOuterRing = false
      return viewer;
  },
  createWMSImageryProvider(props_data) {
    const props = props_data || {}
    if(!props.parameters){
      props.parameters = {
        service : 'WMS',
        format: 'image/png',
        transparent: true,
      }
    }
    if(!props.layers){
      props.layers = props["layer"] || ''
    }
    return new Cesium.WebMapServiceImageryProvider(props)
  },
  createWMTSImageryProvider(props_data){
    const props = props_data || {}
    if(!props.format){
      props.format ="image/jpeg"
    }
    if(!props.tileMatrixSetID){
      props.tileMatrixSetID="EPSG:900913"
    }
    return new Cesium.WebMapTileServiceImageryProvider(props);
  },
  createCesium3DTileset(props_data){
    const props = props_data || {}
    const url = props['url'] || ''
    return Cesium.Cesium3DTileset.fromUrl(url)
  },
  createTdtImageryProvider(style='vec',token='') {
    var options = {
      style, //style: vec、cva、img、cia、ter 
      key:token, // 需去相关地图厂商申请
    }
    return new TdtImageryProvider(options)
  },
  createAmapImageryProvider(style,crs='WGS84') {
    var options = {
      style, // style: img、elec、cva
      crs // 使用84坐标系，默认为：GCJ02
    }
    return new AmapImageryProvider(options)
  },
  createBaiduImageryProvider(style='normal',crs='WGS84') {
    var options = {
      style, // style: img、vec、normal、dark
      crs // 使用84坐标系，默认为：BD09
    }
    return new BaiduImageryProvider(options)
  },
  createGeoVisImageryProvider(style='vec',token='',format='png') {
    var options = {
      style, //style: img、vec、ter, cia,cat,
      key:token, // 需去相关地图厂商申请
      format //format:png、webp(用于style为img)
    }
    return new GeoVisImageryProvider(options)
  },
  createGoogleImageryProvider(style='elec',crs='WGS84') {
    var options = {
      style: 'elec',//style: img、elec、ter,cva,img_cva
      crs: 'WGS84' // 使用84坐标系，默认为：GCJ02, img除外
    }
    return new GoogleImageryProvider(options)
  },
  createTencentImageryProvider(style=1) {
    var options = {
        style: 1 //style: img、1：经典
    }
    return new TencentImageryProvider(options)
  },
  bufferScreenPoint(viewer,point,tolerance){
    //屏幕点坐标缓冲后转成经纬度Rectangle
    //tolerance 像素容差，point屏幕坐标
    if (!viewer || !point || !tolerance) {
        return []
    }
    const minPoint = this.screenPointToDegrees(new Cesium.Cartesian2(point.x-tolerance,point.y+tolerance),viewer)
    const maxPoint = this.screenPointToDegrees(new Cesium.Cartesian2(point.x+tolerance,point.y-tolerance),viewer)
    return [...minPoint,...maxPoint]
  },
  screenPointToDegrees(screenPoint,viewer){
    const cartesian3 = this.screenPointToCartesian3(screenPoint,viewer);
    const cartographic=this.cartesian3ToCartographic(cartesian3,viewer);
    return [Cesium.Math.toDegrees(cartographic.longitude),
        Cesium.Math.toDegrees(cartographic.latitude)]
  },
  screenPointToCartesian3(screenPoint,viewer){
    return viewer.scene.globe.pick(viewer.camera.getPickRay(screenPoint),viewer.scene);
  },
  cartesian3ToCartographic(cartesian3,viewer){
    return viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian3);
  },
  cartographicToCartesian3(cartographic,viewer){
    return viewer.scene.globe.ellipsoid.cartographicToCartesian(cartographic);
  },
  async parseJson(json){
    const features ={}
    json.features.forEach(feature=>{
      features[feature.id] = feature
    })
    const dataSource = await Cesium.GeoJsonDataSource.load(json)
    dataSource.entities.values.forEach(entity=>{
      const feat = features[entity.id]
      if(feat){
        feat.entity = entity
      }
    })
    return Object.values(features) 
},

  parseSingle(feature){
    const json = {
      type: "FeatureCollection",
      features: [feature]
    }
    return new Promise((resolve)=>{
      Cesium.GeoJsonDataSource.load(json).then(dataSource=>{
        dataSource.entities.values.forEach(entity=>{
          entity && resolve(entity)
        })
      })
    })
  },

  async parse(features){
    let feats = features
    if(!Array.isArray(features)){
      feats = [features]
    }
    let entity = null
    const json = {
      type: "FeatureCollection",
      features: feats
    }
    const dataSource = await Cesium.GeoJsonDataSource.load(json)
    dataSource.entities.values.forEach(ent=>{
      entity = ent
    })
    return entity 
  }
}
export default CoreMapTd;